// 例如：倩女端游、逆水寒、流星群侠传、倩女手游。

export interface Project {
  code: string; // 项目标识，唯一
  name: string; // 项目名称
  createTime?: string; // 创建时间
}

// 项目级别
export enum ProjectRole {
  Admin = 'ADMIN', // 管理员
  Allocator = 'ALLOCATOR', // 需求方（发包人）
  InternalContacts = 'INTERNAL_CONTACTS', // 审核方
  ExternalContacts = 'EXTERNAL_CONTACTS', // 制作方
  Watcher = 'WATCHER',
}

// 平台级别
export enum PlatformRole {
  Admin = 'admin', // 管理员
  Developer = 'developer',
  User = 'user',
}

export interface ProjectUserType {
  searchKey: string;
  avatar?: string; // 头像
  name: string;
  department: string;
  value: string;
  label: string;
  nickName?: string; //平台昵称
  fullName?: string; //rbac fullname
  email?: string;
  corpEmail?: string; // 企业邮箱
  phone?: string;
  disabled: boolean;
  title: string;
  platformRole?: PlatformRole[]; // 平台角色
  projectRole?: ProjectRole[]; // 项目角色
  matched?: boolean; // 是否匹配到用户
}

// code码更新
export const PLATFORM_CODE = 'yl_tiangong';

export const PROJECT_ADMINISTRATOR_TAG = 'ADMIN';

export type ProjectDetail = {
  uniqueId: number;
  projectName: string;
  projectCode: string;
  projectType: string;
  tgProjectId: number;
  roles: {
    roleName: string;
    roleCode: string;
    roleType: string;
  }[];
  type: string;
  icon: string;
  commonConfigId?: string;
  museProjectCode?: string;
  usePlatformTemplate?: boolean;
  parentTaskTemplateTotal: number;
  enableSecrecyPublish?: boolean;
  enableApplyRequirements?: boolean;
  activityNum?: number; // 活动数量
};

export type ProjectRule = {
  uniqueId: number;
  projectCode: string;
  versionFileSizeLimit: number;
  versionAttachmentSizeLimit: number;
  reviewAttachmentSizeLimit: number;
  reviewAttachmentFileLimit: number;
  taskAttachmentSizeLimit: number;
  applyFileSizeLimit: number;
};
